import { render, staticRenderFns } from "./RequestManagement.vue?vue&type=template&id=5c217b10&scoped=true&"
import script from "./RequestManagement.vue?vue&type=script&lang=js&"
export * from "./RequestManagement.vue?vue&type=script&lang=js&"
import style0 from "./RequestManagement.vue?vue&type=style&index=0&id=5c217b10&scoped=true&lang=css&"
import style1 from "@/assets/css/requestManagement.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/content.css?vue&type=style&index=2&lang=css&"
import style3 from "@/assets/css/font.css?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c217b10",
  null
  
)

export default component.exports